<template>
  <div>
    <v-card-text class="error-top">
      <w-input
        name="login"
        placeholder="Adres e-mail lub nazwa użytkownika"
        outlined
        :model="schema.login"
        :label="schema.login.$title"
      />

      <password-input name="password" :model="schema.password" />

      <div class="input-description forgot-password-link">
        <router-link :to="{ name: 'resetPasswordEmail' }">Zapomniałem hasła</router-link>

        <router-link class="ml-2" :to="{ name: 'resendConfirm' }">Wyślij link aktywacyjny</router-link>
      </div>
    </v-card-text>

    <v-card-actions>
      <span v-if="wrongLoginData" id="LoginError">{{ wrongLoginData }}</span>

      <v-btn depressed large block type="submit" color="primary" style="margin: auto"> Zaloguj </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { WInput } from '@witkac/vuetify-components';

import PasswordInput from '@/components/forms/PasswordInput';
// @vuese
// Formularz logowania
// @group Forms
export default {
  components: { WInput, PasswordInput },
  props: {
    schema: { type: Object, required: true },
    wrongLoginData: { type: String, required: false }
  },
  data() {
    return {
      showPassword: false
    };
  }
};
</script>

<style>
#LoginError {
  padding: 10px;
  color: #970000 !important;
}
</style>
